(function () {
  'use strict';

  function PreviewOrderCtrl (Common, $state, $stateParams, ordersFactory, $http, $sce, FileDownload, $scope, $location,
    breadcrumbFactory, $uibModal) {
    const vm = this;

    function goTo (state) {
      $state.go(state);
    }

    function receiptAvailable () {
      return !!vm.receiptUrl;
    }

    function odrDocumentsAvailable () {
      return !!vm.odrUrls;
    }

    function downloadReceipt () {
      if (receiptAvailable()) {
        window.open(vm.receiptUrl);
      }
    }

    function downloadOdrSummary () {
      if (odrDocumentsAvailable()) {
        window.open(vm.odrUrls['odrSummary.pdf']);
      }
    }

    function downloadOdrSlip () {
      if (odrDocumentsAvailable()) {
        window.open(vm.odrUrls['odrSlips.pdf']);
      }
    }

    function downloadOdrConfirmation () {
      if (odrDocumentsAvailable()) {
        window.open(vm.odrUrls['odrConfirmation.pdf']);
      }
    }

    function displayPdf (url) {
      vm.content = $sce.trustAsResourceUrl(url);
    }

    function checkStatus () {
      return vm.order.status === 'UNPROCESSED';

    }

    function openConfirmationDialog () {
      if (checkStatus()) {
        $uibModal.open({
          templateUrl: 'components/orders/cancel-order/cancel-order.html',
          controller: 'CancelOrderCtrl',
          controllerAs: 'ctrl',
          backdrop: 'static',
          backdropClass: 'common-modal-backdrop',
          resolve: {
            orderId: function () {
              return vm.order.orderId;
            },

            cartId: function () {
              return vm.order.cartId;
            }
          }
        }).result.then(getOrder);
      }
    }

    function activate (order) {
      // data bindings
      vm.order = ordersFactory.restructureToDisplay(order);
      vm.receiptUrl = order.receiptUrl;
      vm.odrUrls = order.odrUrls;

      if (!vm.order) {
        $state.go('main.orders');
        return;
      }

      vm.language = pnTopbar.language;
      vm.templateUrl = 'components/orders/preview-order/preview-order.html';
      vm.showContent = true;
      vm.inProd = web2print.env.stage === 'prod';
      vm.hideSpec = true;
      vm.isOwnMaterial = Common.get('previewOrder.ownMaterial');

      // methods
      vm.goTo = goTo;
      vm.receiptAvailable = receiptAvailable;
      vm.odrDocumentsAvailable = odrDocumentsAvailable;
      vm.downloadReceipt = downloadReceipt;
      vm.downloadOdrSummary = downloadOdrSummary;
      vm.downloadOdrSlip = downloadOdrSlip;
      vm.downloadOdrConfirmation = downloadOdrConfirmation;
      vm.openConfirmationDialog = openConfirmationDialog;
      vm.checkStatus = checkStatus;
      vm.orderId = vm.order.orderId;

      if (!breadcrumbFactory.checkItemIfExists(vm.order.cartId)) {
        breadcrumbFactory.addItem(vm.order.cartId, 'main.order');
      }

      displayPdf(order.materialUrl);


      $scope.$on('changeLanguage', function (ev, language) {
        vm.language = language;
      });
    }

    function redirectToLanding (err) {
      console.log(err);
      $location.path('/');
    }

    function getOrder () {
      // intiallize display models first
      vm.preview = true;
      vm.orderPage = true;
      vm.showContent = false;
      ordersFactory.getOrderById($stateParams.id)
        .then(activate, redirectToLanding);
    }

    getOrder();
  }

  angular.module('web2print.orders')
    .controller('PreviewOrderCtrl', PreviewOrderCtrl);

  PreviewOrderCtrl.$inject = ['Common', '$state', '$stateParams', 'ordersFactory', '$http', '$sce', 'FileDownload', '$scope', '$location', 'breadcrumbFactory', '$uibModal'];
})();
